import { render, staticRenderFns } from "./CommentsTableBase.vue?vue&type=template&id=da9ed4c8&scoped=true&"
import script from "./CommentsTableBase.vue?vue&type=script&lang=ts&"
export * from "./CommentsTableBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9ed4c8",
  null
  
)

export default component.exports